var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('PaymentListItem',{key:item.patient_info.image_id,attrs:{"patient-info":item.patient_info,"price":item.current_price}})}))}
var staticRenderFns = []

export { render, staticRenderFns }